import { NAMESPACE } from 'locale'
import { generalConstants } from 'locale/general'
import { useTranslation } from 'react-i18next'

const useRequiredRule = () => {
  const { t } = useTranslation(NAMESPACE.GENERAL)
  
  const requiredRule = (fieldName: string) => ({
    required: true,
    message: t(generalConstants.PLEASE_ENTER_FIELD_NAME, { fieldName }),
  })
  
  return requiredRule
}

export default useRequiredRule